import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';


function ModalVaccineAnimal({ show, close, save }) {

    const toConfrim = async () => {
        await save();
    };

    const handleClose = () => {
        close()
    }

    return (
        <Modal
            show={show}
            size="md"
            onHide={() => handleClose(false)}
            centered
        >
            <Modal.Header closeButton className="pb-4">
            </Modal.Header>
            <Modal.Body className="p-4">
                <div className="mb-2 text-center">
                  
                    <div className="py-2">
                        <button className="btn btn-danger px-4 mr-2" onClick={() => handleClose()}>ยกเลิก</button>
                        <button className="btn btn-success px-4" onClick={() => toConfrim()}>ตกลง</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ModalVaccineAnimal
